interface CsvRow {
	answers: (number | null | undefined)[];
}

interface DownloadCsvParams {
	questions: string[];
	rows: CsvRow[];
	filename?: string;
}

function escapeCsvField(value: string): string {
	if (value.includes(',') || value.includes('"') || value.includes('\n')) {
		return `"${value.replace(/"/g, '""')}"`;
	}
	return value;
}

export function downloadCsv({
	questions,
	rows,
	filename = 'relatorio.csv',
}: DownloadCsvParams) {
	const header = questions.map(escapeCsvField).join(',');

	const body = rows
		.map((row) =>
			questions
				.map((_, colIndex) => {
					const val = row.answers[colIndex];
					return val != null ? String(val) : '';
				})
				.join(','),
		)
		.join('\n');

	const bom = '\uFEFF';
	const csv = bom + header + '\n' + body;

	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
	link.click();

	URL.revokeObjectURL(url);
}
